import { Box, Flex, Text } from "rebass";
import Image from "next/image";
import { Tiles } from "@rebass/layout";
import styles from "../styles/Home.module.css";

const FeatureCard = ({
  title,
  body,
  image,
  size,
  isDeplay,
}: {
  title: string;
  body: string;
  image: string;
  size: number;
  isDeplay: boolean;
}) => {
  return (
    <Flex
      p={["30px", "40px", "60px"]}
      sx={{
        background: "rgba(45,45,45, 0.4)",
        padding: "80px",
        borderRadius: "24px",
        alignItems: "flex-start",
        maxWidth: "500px",
        maxHeight: "350px",
      }}
      flexDirection="column"
    >
      <Box className={isDeplay ? styles.floatingDelay : styles.floating} width={[50,65,80]} height={[50,65,80]}>
        <Image
          src={image}
          alt="secure-box"
          width={"100%"}
          height={"100%"}
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />
      </Box>
      <Text
        as="h1"
        fontSize={["1.5em", "1.8em", "2em"]}
        sx={{ color: "#f9f9f9", fontFamily: "Inter,sans-serif", py: "12px" }}
      >
        {title}
      </Text>
      <Text
        fontSize={["1em", "1.2em", "1.3em"]}
        sx={{ color: "#999999", fontFamily: "Inter,sans-serif" }}
      >
        {body}
      </Text>
    </Flex>
  );
};

const Feature = () => {
  return (
    <Flex
      sx={{
        minHeight: "90vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        alignItems: "center",
        // justifyContent: "center",
        position: "relative",
        overflowY: "visible",
      }}
    >
      <Text
        fontSize={["3em", "4em", "5em"]}
        sx={{ fontFamily: "Montserrat,sans-serif", fontWeight: "bold" }}
      >
        <span style={{ color: "#7678ED" }}>.</span>{" "}Why{" "}
        <span style={{ display: "inline-block" }}>
          lilico{" "}<span style={{ color: "#FC814A" }}>.</span>
        </span>
      </Text>
      <Text
        fontSize={["1.2em", "1.5em", "1.8em"]}
        sx={{
          fontFamily: "Montserrat,sans-serif",
          fontWeight: 500,
          color: "#E6E6E6",
          my: "12px",
          textAlign: "center",
        }}
      >
        Lilico is bringing a transcendent experience to your crypto assets on
        web3.
      </Text>
      <Flex sx={{ flexGrow: 1 }} />
      <Tiles
        columns={[1, 2, 2]}
        sx={{ userSelect: "none", my: "20px", gap: "30px", mx: "20px", }}
      >
        <FeatureCard
          title="Non-Custodial"
          body="No one, not even us, can access your wallet."
          image="/images/key.png"
          size={80}
          isDeplay={false}
        />
        <FeatureCard
          title="Privacy is Respected"
          body="None of your data is kept on our end and Lilico doesn’t track any personal information."
          image="/images/secure-box.png"
          size={80}
          isDeplay={true}
        />
        <FeatureCard
          title="Find By Domain"
          body="Use just your lilico username or domain (.find or .fn) to find your friends to send and receive tokens."
          image="/images/search.png"
          size={80}
          isDeplay={true}
        />
        <FeatureCard
          title="Explore dApp on Flow"
          body="Connect to your favourite Flow dApp with lilico."
          image="/images/helm.png"
          size={80}
          isDeplay={false}
        />
      </Tiles>
      <Flex sx={{ flexGrow: 1 }} />
    </Flex>
  );
};

export default Feature;
